import { React } from '../../Imports';
import { IConfigServiceInjectedProps, ConfigService } from '$State/ConfigFreezerService';
import { TooltipWedge } from '../Shared/TooltipWedge';
import * as scssStyles from '$CSS/settings.scss';

interface IWidgetTooltipProps {
    prompt: string | React.ReactNode;
    description: React.ReactNode;
    contentPosition: "topCenter" | "bottomRight";
    contentPositionRight?: string;
    hoverTooltipDisabled?: boolean;
}

type WidgetTooltipProps = IWidgetTooltipProps & IConfigServiceInjectedProps;

const styles = require('./WidgetTooltip.scss') as {
    container: string;
    targetHover: string;
    content: string;
    contentGeotab: string;
    contentEncompass: string;
    wedge: string;
    prompt: string;
    contentAlignedRightBottom: string;
    contentCenteredAbove: string;
    wedgeCenteredAbove: string;
    targetVisible: string;
    targetHidden: string;
};

class _WidgetTooltip extends React.PureComponent<WidgetTooltipProps, {}> {
    state = {
        tooltipContentVisible: !this.props.hoverTooltipDisabled,
    };

    render(): JSX.Element {
        const isEncompass = scssStyles.styleEnvironment === 'encompass';
        const envContentStyles = isEncompass ? styles.contentEncompass : styles.contentGeotab;

        const contentPositionStyle = () => {
            switch (this.props.contentPosition) {
                case 'topCenter':
                    return styles.contentCenteredAbove;
                case 'bottomRight':
                default:
                    return styles.contentAlignedRightBottom;
            }
        };

        const wedgePositionStyle = () => {
            switch (this.props.contentPosition) {
                case 'topCenter':
                    return styles.wedgeCenteredAbove;
                case 'bottomRight':
                default:
                    return styles.wedge;
            }
        };

        const handleOnClickTooltipIcon = () => {
            this.setState({ tooltipContentVisible: !this.state.tooltipContentVisible });
        };

        return (
            <div className={styles.container} onClick={this.props.hoverTooltipDisabled ? handleOnClickTooltipIcon : undefined}>
                <div
                    className={
                        this.props.hoverTooltipDisabled
                            ? this.state.tooltipContentVisible
                                ? styles.targetVisible
                                : styles.targetHidden
                            : styles.targetHover
                    }
                >
                    <div className={styles.prompt}>{this.props.prompt}</div>
                    <div
                        className={styles.content + ' ' + envContentStyles + ' ' + contentPositionStyle()}
                        style={{ right: this.props.contentPositionRight ? this.props.contentPositionRight : '0' }}
                    >
                        <div className={wedgePositionStyle()}>
                            <TooltipWedge />
                        </div>
                        {this.props.description}
                    </div>
                </div>
            </div>
        );
    }
}

export const WidgetTooltip = ConfigService.inject(_WidgetTooltip);
